// S312: genel widget sayfası; menüde, Özet'in widget çizicisiyle çalışan firma sayfası.
// Sayfanın başlığı, açıklaması ve widget listesi `firm_panel_screens.config` içinde (SQL ile) tanımlanır;
// yeni bir firma ekranı için React kodu gerekmez.
import { DynamicDashboard } from '../components/DynamicDashboard';
import type { EkranProps } from '../ekranKayitDefteri';

export function WidgetSayfasi({ screen }: EkranProps) {
  const cfg = screen.config;
  // Widget kodu YALNIZ bu ekranın kaynaklarına çözülür: menüdeki bir raporla aynı kodu taşısa bile
  // menü raporuna gitmez. API rol izni olmayan kaynağı sözlüğe koymaz → o widget çizilmez.
  const kaynaklar: Record<string, number> = {};
  for (const [anahtar, k] of Object.entries(screen.kaynaklar ?? {})) kaynaklar[anahtar] = k.sourceId;

  return (
    <DynamicDashboard
      widgets={cfg?.widgets ?? []}
      reports={[]}
      widgetSources={kaynaklar}
      baslik={screen.title}
      aciklama={cfg?.aciklama}
      varsayilanDonem={cfg?.varsayilanDonem}
      cozulmeyeniGizle
      donemSecimi={cfg?.donemSecimi !== false}
    />
  );
}
